/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type NotificationEntityType =
  (typeof NotificationEntityType)[keyof typeof NotificationEntityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationEntityType = {
  TASK: "TASK",
  ACTION_POINT: "ACTION_POINT",
  CHECKPOINT: "CHECKPOINT",
  DELIVERABLE: "DELIVERABLE",
  PHASE: "PHASE",
  FEEDBACK: "FEEDBACK",
} as const;
